import { Component, ElementRef, ChangeDetectorRef, AfterViewInit, Input } from '@angular/core';

import { LoadingService } from '../../services';
import { BaseComponent } from '../base/base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  styleUrl: 'loading.component.scss',
  templateUrl: 'loading.component.html',
})
export class LoadingComponent extends BaseComponent implements AfterViewInit {
  @Input() static = false;

  constructor(
    private loadingScreenService: LoadingService,
    private _elmRef: ElementRef,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this._elmRef.nativeElement.style.display = 'none';
    this.loadingScreenService.loading$.pipe(takeUntil(this.destroy$)).subscribe((status: boolean) => {
      this._elmRef.nativeElement.style.display = status ? 'block' : 'none';
      this._changeDetectorRef.detectChanges();
    });
  }
}
